import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { BetaWarningComponent } from './beta-warning.component';
import { SharedModule }         from '../../shared/shared.module';

@NgModule({
  declarations: [
    BetaWarningComponent
  ],
  entryComponents: [
    BetaWarningComponent
  ],
  exports: [
    BetaWarningComponent
  ],
  imports: [
    SharedModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class BetaWarningModule {}
